import styled, { css } from "styled-components";

import { smMedia } from "../../../utils/getMediaStyle";
import { mobileBreakpoint, mobileHeightBreakpoint } from "../constants";
import { colors, font } from "../styles";

const BaseHeaderText = styled.div`
  width: 100%;
  ${({ align }) => (align ? `text-align: ${align}` : "text-align: center;")};
  ${(props) =>
    props.themeable && props.theme && `color: ${props.theme.text.mainBody};`}
`;

const BaseBodyText = styled.div`
  ${({ align }) => (align ? `text-align: ${align}` : "text-align: left;")};
  margin-bottom: 0;
`;
export const HeaderText = styled.h3`
  font-family: ${font.header};
  font-weight: bold;
  color: ${(theme) => theme.primaryText || colors.black};
`;

export const LargeHeaderText = styled(BaseHeaderText)`
  font-family: ${font.header};
  font-weight: bold;
  font-size: 48px;
  line-height: 58px;
  text-align: left;
  @media screen and (max-width: ${mobileBreakpoint}),
    screen and (max-height: ${mobileHeightBreakpoint}) {
    font-size: 40px;
    line-height: 50px;
    text-align: center;
  }
`;

export const MediumHeaderText = styled(BaseHeaderText)`
  font-family: ${font.header};
  font-size: 36px;
  font-weight: bold;
  ${smMedia`
    font-size: 20px;
  `}
`;

export const SmallHeaderText = styled(BaseHeaderText)`
  font-family: ${font.header};
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 1px;
  font-weight: bold;
  @media screen and (max-width: ${mobileBreakpoint}),
    screen and (max-height: ${mobileHeightBreakpoint}) {
    font-size: 12px;
    line-height: 12px;
  }
`;

export const SmallBodyText = styled(BaseBodyText)`
  font-family: ${font.body};
  width: ${(props) => (props.width ? props.width : 50)}%;
  font-size: 14px;
  margin: 0;
  ${(props) => props.color && `color: ${props.color}`};
  ${(props) =>
    props.themeable && props.theme && `color: ${props.theme.text.mainBody};`}

  @media screen and (max-width: ${mobileBreakpoint}),
    screen and (max-height: ${mobileHeightBreakpoint}) {
    font-size: 10px;
  }
`;

export const MediumBodyText = styled(BaseBodyText)`
  font-family: ${font.body};
  font-size: 18px;
  color: #515151;
  font-stretch: 100%;
  font-style: ${(props) => (props.fontStyle ? props.fontStyle : "normal")};
  font-weight: 300;
  letter-spacing: -0.2px;
  line-height: 28px;
  margin-block-end: 30px;
  margin-block-start: 0px;
  margin-bottom: 30px;
  margin-inline-end: 0px;
  margin-inline-start: 0px;
  margin-top: 0px;
  @media screen and (max-width: ${mobileBreakpoint}),
    screen and (max-height: ${mobileHeightBreakpoint}) {
    font-size: 12px;
  }
`;

export const LargeBodyText = styled(BaseBodyText)`
  font-family: ${font.body};
  font-size: 28px;
  color: ${(props) => props.theme.color.text.secondary};
  font-stretch: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
  text-align: left;
  ${smMedia`
    font-size: 16px;
    line-height: 24px;
  `}
`;

export const textWithLoadingDots = css`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: ${colors.darkGrey2};

  &:after {
    content: " .";
    animation: dots 1s steps(5, end) infinite;
  }
  @keyframes dots {
    0%,
    20% {
      color: ${colors.darkGrey2};
      text-shadow: 0.25em 0 0 ${colors.darkGrey2}, 0.5em 0 0 ${colors.darkGrey2};
    }
    40% {
      color: ${colors.lightGrey2};
      text-shadow: 0.25em 0 0 ${colors.darkGrey2}, 0.5em 0 0 ${colors.darkGrey2};
    }
    60% {
      text-shadow: 0.25em 0 0 ${colors.lightGrey2},
        0.5em 0 0 ${colors.darkGrey2};
    }
    80%,
    100% {
      text-shadow: 0.25em 0 0 ${colors.lightGrey2},
        0.5em 0 0 ${colors.lightGrey2};
    }
  }
`;
